import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useParams, Navigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import termsRaw from '../../../../legal/terms-and-conditions.md?raw';
import privacyRaw from '../../../../legal/privacy-policy.md?raw';
import styles from '../components/UI/LegalModal.module.css';
import pageStyles from './LegalPage.module.css';

export function LegalPage() {
  const { type } = useParams<{ type: string }>();

  if (type !== 'terms' && type !== 'privacy') {
    return <Navigate to="/" replace />;
  }

  const title = type === 'terms' ? 'Terms and Conditions' : 'Privacy Policy';
  const content = type === 'terms' ? termsRaw : privacyRaw;

  return (
    <div className={pageStyles.page}>
      <div className={pageStyles.container}>
        <Link to="/" className={pageStyles.back}>
          <ArrowLeft size={16} />
          <span>Back</span>
        </Link>
        <h1 className={pageStyles.title}>{title}</h1>
        <div className={styles.prose}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
